export const companyInfo = {
  Name: "HOTSAUCE TECHNOLOGIES",
  Content: [
    "Tel: 678.325.5300",
    " 7001 Peachtree Industrial Blvd Suite 4200 Norcross, GA 30092"
  ]
}

export const copyrightInfo =
  ["@ ", new Date().getFullYear(), " HSAC LLC DBA HotSauce Technologies. All rights reserved."]